import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box,
    useTheme
} from '@mui/material';
import { SystemUpdate as SystemUpdateIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const VersionUpdateModal = ({ open, versionData, onUpdate, onLater }) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();

    if (!versionData) return null;

    const { version, force_update, messages, message: defaultMessage } = versionData;

    // Determine message based on language
    let messageText = '';
    const currentLang = i18n.language || 'es';

    if (messages && messages[currentLang]) {
        messageText = messages[currentLang];
    } else if (defaultMessage) {
        messageText = defaultMessage;
    } else {
        messageText = t('update.message', { version, defaultValue: `New version ${version} available.` });
    }

    return (
        <Dialog
            open={open}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 1,
                    background: 'linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%)',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
                }
            }}
        >
            <DialogContent sx={{ textAlign: 'center', pt: 4, pb: 2 }}>
                <Box
                    sx={{
                        width: 80,
                        height: 80,
                        borderRadius: '50%',
                        bgcolor: 'primary.light',
                        color: 'primary.main',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 24px auto',
                        boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                    }}
                >
                    <SystemUpdateIcon sx={{ fontSize: 40 }} />
                </Box>

                <Typography variant="h5" component="h2" gutterBottom fontWeight="bold">
                    {t('update.title', 'Update Available!')}
                </Typography>

                <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                    {messageText}
                </Typography>

                {force_update && (
                    <Typography variant="caption" color="error.main" fontWeight="bold">
                        {t('update.force_update', 'This update is required.')}
                    </Typography>
                )}
            </DialogContent>

            <DialogActions sx={{ flexDirection: 'column', gap: 1.5, p: 3 }}>
                <Button
                    variant="contained"
                    fullWidth
                    size="large"
                    onClick={() => onUpdate(versionData)}
                    sx={{
                        borderRadius: 2,
                        py: 1.5,
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        boxShadow: '0 4px 12px rgba(33, 150, 243, 0.3)'
                    }}
                >
                    {t('update.button_update', 'Update Now')}
                </Button>

                {!force_update && (
                    <Button
                        variant="text"
                        fullWidth
                        onClick={onLater}
                        sx={{
                            borderRadius: 2,
                            color: 'text.secondary'
                        }}
                    >
                        {t('update.button_later', 'Maybe Later')}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default VersionUpdateModal;
